module.exports = __webpack_public_path__ + "img/Filter.ae0d3c0d.svg";